import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87a3665a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sales-container flex-wrapper entire-height" }
const _hoisted_2 = { class: "sales-header" }
const _hoisted_3 = {
  key: 0,
  class: "payment-overview-block-wrapper flex-wrapper flex-height"
}
const _hoisted_4 = { class: "payment-overview-block" }
const _hoisted_5 = { class: "payment-search-wrapper" }
const _hoisted_6 = { class: "payment-search-row" }
const _hoisted_7 = { class: "search-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Year ", -1))
const _hoisted_9 = { class: "search-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Round ", -1))
const _hoisted_11 = { class: "search-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Status ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_15 = { class: "search-btn" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_18 = { class: "payment-overview-block mt-10 flex-wrapper flex-height" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, "|", -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, "|", -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, "|", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, "|", -1))
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "pagination-container d-f justify-e"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_tab_bar = _resolveComponent("tab-bar")!
  const _component_YearPicker = _resolveComponent("YearPicker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_set_modal = _resolveComponent("set-modal")!
  const _component_view_modal = _resolveComponent("view-modal")!
  const _component_upload_detail = _resolveComponent("upload-detail")!
  const _component_download_modal = _resolveComponent("download-modal")!
  const _component_demo_c_d_set_modal = _resolveComponent("demo-c-d-set-modal")!
  const _component_demo_c_d_preview_modal = _resolveComponent("demo-c-d-preview-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { dataSource: [] }),
        _createVNode(_component_tab_bar, {
          data: _ctx.entityList,
          activeKey: _ctx.entity,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity) = $event)),
          onOnTabChange: _ctx.handleTabChange
        }, null, 8, ["data", "activeKey", "onOnTabChange"])
      ]),
      (_ctx.entityList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_YearPicker, {
                      style: {"width":"100%"},
                      value: _ctx.payoutYear,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payoutYear) = $event)),
                      allowClear: false,
                      placeholder: "Please select"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_a_select, {
                      value: _ctx.payoutRound,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payoutRound) = $event)),
                      class: "sel-inp-size",
                      placeholder: "Please select",
                      allowClear: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roundList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_a_select, {
                      value: _ctx.status,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                      class: "sel-inp-size",
                      placeholder: "Please select",
                      allowClear: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.code,
                            key: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _hoisted_13,
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.$btnPermissions('ESPA0001'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        style: {"margin-right":"15px"},
                        onClick: _ctx.reset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.$btnPermissions('ESPA0002'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        onClick: _ctx.search
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_table_wrapper, { "is-pagination": _ctx.isPagination }, {
                default: _withCtx((slotProps) => [
                  _createVNode(_component_a_table, {
                    scroll: {
                y: slotProps.tableHeight - 8,
                x: _ctx.tableWidth,
              },
                    dataSource: _ctx.data,
                    columns: _ctx.filteredColumn,
                    rowKey: "payoutRound",
                    pagination: false
                  }, _createSlots({
                    round: _withCtx(({ record }) => [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.handleViewModalShow(record)),
                        class: "link"
                      }, _toDisplayString(record.payoutRound), 9, _hoisted_19)
                    ]),
                    documentOperation: _withCtx(({ record }) => [
                      (_ctx.$btnPermissions('ESPA0003'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.handleSetModalShow(record)),
                            class: _normalizeClass(["link", {
                    disabled: !(
                      _ctx.approvedStatusList.includes(record.status) &&
                      record.identification
                    ),
                  }])
                          }, "Set", 10, _hoisted_20))
                        : _createCommentVNode("", true),
                      _hoisted_21,
                      (_ctx.$btnPermissions('ESPA0004'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.handleDownloadShow(record)),
                            class: _normalizeClass(["link", {
                    disabled: !_ctx.approvedStatusList.includes(record.status),
                  }])
                          }, "Download", 10, _hoisted_22))
                        : _createCommentVNode("", true)
                    ]),
                    operation: _withCtx(({ record }) => [
                      (_ctx.$btnPermissions('ESPA0005'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.handleNext(record)),
                            class: _normalizeClass(["link", {
                    disabled:
                      !record.identification ||
                      _ctx.notApprovedStatusList.includes(record.status),
                  }])
                          }, "Next", 10, _hoisted_23))
                        : _createCommentVNode("", true),
                      _hoisted_24,
                      (_ctx.$btnPermissions('ESPA0006'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.handleView(record)),
                            class: _normalizeClass(["link", {
                    disabled:
                      // record.identification ||
                      _ctx.notApprovedStatusList.includes(record.status),
                  }])
                          }, "View", 10, _hoisted_25))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (_ctx.entity != 'FBAC')
                      ? {
                          name: "DCD",
                          fn: _withCtx(({ record }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["link", { disabled: !record.demoCarSetButtonHighlight }]),
                              onClick: ($event: any) => (_ctx.handleDemoCDSetShow(record, _ctx.entity))
                            }, "Set", 10, _hoisted_26),
                            _hoisted_27,
                            _createElementVNode("span", {
                              class: _normalizeClass(["link", { disabled: !record.demoCarPreviewButtonHighlight }]),
                              onClick: ($event: any) => (_ctx.handleDemoCDPreviewShow(record, _ctx.entity))
                            }, "Preview", 10, _hoisted_28),
                            _hoisted_29,
                            _createElementVNode("span", {
                              class: _normalizeClass(["link", { disabled: !record.demoCarViewButtonHighlight }]),
                              onClick: ($event: any) => (_ctx.handleDemoCDViewShow(record, _ctx.entity))
                            }, "View", 10, _hoisted_30)
                          ])
                        }
                      : undefined
                  ]), 1032, ["scroll", "dataSource", "columns"])
                ]),
                _: 1
              }, 8, ["is-pagination"]),
              (_ctx.isPagination)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_a_pagination, {
                      total: _ctx.total,
                      "show-size-changer": "",
                      "show-total": (total) => `共 ${total} 条`,
                      onChange: _ctx.pageChange,
                      onShowSizeChange: _ctx.sizeChange,
                      pageSize: _ctx.pageSize,
                      "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
                      current: _ctx.pageNumber,
                      "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNumber) = $event)),
                      pageSizeOptions: ['10', '20', '30', '40', '50']
                    }, {
                      buildOptionText: _withCtx((props) => [
                        _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
                      ]),
                      _: 1
                    }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "current"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_set_modal, {
      onOnUploadShow: _ctx.handleUploadShow,
      visible: _ctx.setModalVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.setModalVisible) = $event)),
      entity: _ctx.entity,
      payoutRound: _ctx.curPayoutRound
    }, null, 8, ["onOnUploadShow", "visible", "entity", "payoutRound"]),
    _createVNode(_component_view_modal, { ref: "viewModal" }, null, 512),
    (_ctx.uploadModalVisible)
      ? (_openBlock(), _createBlock(_component_upload_detail, {
          key: 0,
          isUploadVisible: _ctx.uploadModalVisible,
          onCloseUploadVisible: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadModalVisible = false)),
          round: _ctx.curPayoutRound,
          entity: _ctx.entity
        }, null, 8, ["isUploadVisible", "round", "entity"]))
      : _createCommentVNode("", true),
    _createVNode(_component_download_modal, { ref: "downloadModal" }, null, 512),
    _createVNode(_component_demo_c_d_set_modal, {
      ref: "demoCDSetModal",
      onSet: _ctx.search
    }, null, 8, ["onSet"]),
    _createVNode(_component_demo_c_d_preview_modal, {
      ref: "demoCDPreviewModal",
      onSet: _ctx.search
    }, null, 8, ["onSet"])
  ], 64))
}